/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Box, Grid } from '@mui/material';
import { contactHeaders } from '@/components/ClientDetailEntry/clientDetailData';
import UpdateContactField from '@/components/ClientDetailEntry/UpdateContactField';

const OldContactSection = ({ contact = {} }) => {
	const fields = Object.entries(contactHeaders).filter(([key, header]) => key !== 'IsPrimary');

	return (
		<Box sx={{ marginBottom: '18px', padding: '12px' }}>
			{fields.map(([key, header]) => (
				<Grid container padding={'1em 0 0.5em'} key={`detail-entry-${key}`}>
					<Grid size={12}>
						<UpdateContactField header={key} title={header} contact={contact} />
					</Grid>
				</Grid>
			))}
		</Box>
	);
};

export default OldContactSection;
